import { RotateCcw, WifiOff } from 'lucide-react';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from 'react-i18next';

import { useDemoMode } from '@/app/providers/DemoModeContext';
import { useNetworkStatus } from '@/hooks/useNetworkStatus';

export function OfflineStatusModal() {
  const { isOnline } = useNetworkStatus();
  const { isDemoActive } = useDemoMode();
  const { t } = useTranslation();
  const [isRetrying, setIsRetrying] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isPressed, setIsPressed] = useState(false);

  useEffect(() => {
    if (!isOnline && !isDemoActive) {
      setIsModalOpen(true);
    }
  }, [isOnline, isDemoActive]);

  const handleRetry = () => {
    setIsPressed(true);
    setTimeout(() => {
      setIsPressed(false);
    }, 200);

    if (!isOnline) return;
    setIsRetrying(false);
    setIsModalOpen(false);
    // window.location.reload();
  };

  if (!isModalOpen) return null;

  return createPortal(
    <div className="offline-modal-overlay" role="dialog" aria-modal="true">
      <div className="offline-modal-card">
        <div className="offline-modal-accent-line" />
        <div className="offline-modal-content">
          <div className="offline-modal-header">
            <div className="offline-modal-icon">
              <WifiOff size={20} />
            </div>
            <div>
              <p className="offline-modal-kicker">{t('offline.connectionLost')}</p>
              <h3 className="offline-modal-title">{t('offline.youAreOffline')}</h3>
            </div>
          </div>

          <div className="offline-modal-message">
            <p>{t('offline.message')}</p>
          </div>

          <button
            type="button"
            className="offline-modal-retry"
            style={{
              transform: isPressed ? 'scale(0.95)' : 'scale(1)',
              transition: 'transform 100ms',
            }}
            onClick={handleRetry}
          >
            <RotateCcw size={16} className={isRetrying ? 'animate-spin' : ''} />
            {t('offline.retry')}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
